/**
 *  update by tannc 2018年12月24日20:33:50
 */

import { VERSION_SAVE_API, VERSION_ENABLE_API, VERSION_API } from '../resource/index'
import axios from '../config/axios.config'
export default {

  async save (params) {
    return await axios.save(VERSION_SAVE_API, {}, params)
  },
  async enableOrDisable (params) {
    return await axios.update(VERSION_ENABLE_API, params, {})
  },
  async fetchData (params) {
    return await axios.get(VERSION_API, params)
  }

}



// WEBPACK FOOTER //
// ./src/service/versionService.js